(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["all-blog-posts"] && !Shopify.designMode) return;
  try {
    
  Alpine.asyncData('AllBlogArticles', '@components/all-blog-articles');
  Alpine.asyncData('DynamicBlogArticle', '@components/all-blog-articles');

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  Alpine.asyncData('RecommendedProducts', '@components/recommended-products');
  Alpine.asyncData('RecommendedProductsSearch', '@components/recommended-products');
  Alpine.asyncData('ProductForm', '@components/product-page');

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-list-search"] && !Shopify.designMode) return;
  try {
    
  Alpine.asyncData('CollectionSearch', '@components/collection-search');

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-ajax-search"] && !Shopify.designMode) return;
  try {
    
  Alpine.asyncData('search', '@components/search');

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luxe-product-builder"] && !Shopify.designMode) return;
  try {
    
  Alpine.asyncData('LuxeBuilder', '@components/luxe-builder');

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  Alpine.asyncData('ProductPage', '@components/product-page');

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["required-item"] && !Shopify.designMode) return;
  try {
    
  Alpine.asyncData('RequiredItem', '@components/required-item');

  } catch(e) { console.error(e); }
})();
})();
